import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	addComponent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addCompassComponent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	addComponent: {
		id: 'project-components.create-component-button.trigger',
		defaultMessage: 'Create component',
		description: 'Button text for users to create new components.',
	},
	addCompassComponent: {
		id: 'project-components.create-compass-component-button.trigger',
		defaultMessage: 'Create Compass component',
		description: 'Button text for users to create new components within the Compass product.',
	},
});
export default messages;
